import styled from 'styled-components';
import { key } from 'styled-theme';
import { BASE } from '@sizeid/commons/components/Box/constants';

export default styled.div`
  background: ${key('colors.white')};
  border: 1px solid ${key('colors.black.light[50]')};
  border-radius: ${key('sizes.borderRadius')};
  box-shadow: ${key('outlines.shadow.default')};
  padding: ${2 * BASE}px;
  text-align: center;

  > h2,
  > h3,
  > h4 {
    &:first-child {
      margin-top: 0;
    }
  }
`;
